function _escapeDelimiters(s: string, d: string): string {
  // CSV has much stricter requirements for what must be escaped, so we must do two separate checks
  switch (d) {
    case '\t':
      return s.replace(/\t/g, ' ');
    case ',':
      // string must be enclosed in quotes
      if (/[",\n\r]/.test(s)) {
        s = s.replace(/"/g, '""');
        return `"${s}"`;
      } else {
        return s;
      }
    default:
      return s;
  }
}

function _formatRow(row: Array<string>, delimiter: string): string {
  return row.map((cell) => _escapeDelimiters(cell, delimiter)).join(delimiter);
}

export function formatRows(rows: Array<Array<string>>, delimiter: string): string {
  let result = rows.map((row) => _formatRow(row, delimiter)).join('\n');
  result += '\n';
  return result;
}
